export default __webpack_public_path__ + "static/media/skovstykket-townhouse-6-rooms-07.c1a0e8b0.jpg";